const voice = {
  title: "Announcements",
  description: "Tenak.ai / Studio Juno / Notes Nebula",
};
export default voice;
